import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaTrophy } from "react-icons/fa";
import { GiReceiveMoney } from "react-icons/gi";
import { TbMoneybag, TbUsersGroup } from "react-icons/tb";
import apiCall, { API_CLOSING_PREFIX } from "../../API/API";
import "./ClosingCron.css";

const ACTIONS = [
  {
    endpoint: "/achieve_user_ranks_link",
    label: "Achieve User Ranks",
    description: "Assign user ranks from the current team conditions.",
    icon: FaTrophy,
  },
  {
    endpoint: "/roi_income_link",
    label: "ROI Income",
    description: "Run the ROI income closing.",
    icon: GiReceiveMoney,
  },
  {
    endpoint: "/roi_level_income_link",
    label: "ROI Level Income",
    description: "Run the ROI level income closing.",
    icon: TbUsersGroup,
  },
  {
    endpoint: "/salary_income_link",
    label: "Salary Income",
    description: "Run the salary income closing.",
    icon: TbMoneybag,
  },
];

const responseMessage = (data, label) => {
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  return `${label} completed`;
};

const ClosingCron = () => {
  const [loadingKey, setLoadingKey] = useState(null);
  const [pending, setPending] = useState(null);
  const [results, setResults] = useState({});

  const runAction = async (action) => {
    setPending(null);
    setLoadingKey(action.endpoint);
    const { data, error } = await apiCall(
      "GET",
      action.endpoint,
      null,
      false,
      API_CLOSING_PREFIX
    );
    setLoadingKey(null);

    if (error) {
      setResults((prev) => ({
        ...prev,
        [action.endpoint]: { ok: false, message: error.message || `${action.label} failed` },
      }));
      toast.error(error.message || `${action.label} failed`);
      return;
    }

    const message = responseMessage(data, action.label);
    setResults((prev) => ({
      ...prev,
      [action.endpoint]: { ok: true, message },
    }));
    toast.success(message);
  };

  return (
    <section className="closing-cron">
      <div className="closing-cron__head">
        <h1>Closing</h1>
        <p>Hit each closing job once. These calls credit income, so confirm before you run them.</p>
      </div>

      <div className="closing-cron__grid">
        {ACTIONS.map((action, index) => {
          const Icon = action.icon;
          const result = results[action.endpoint];
          const busy = loadingKey === action.endpoint;
          return (
            <article key={action.endpoint} className="closing-cron__card">
              <p className="closing-cron__step">Step {index + 1}</p>
              <div className="closing-cron__card-head">
                <span className="closing-cron__icon" aria-hidden="true">
                  <Icon />
                </span>
                <div>
                  <h2>{action.label}</h2>
                  <p>{action.description}</p>
                </div>
              </div>
              <code className="closing-cron__endpoint">{action.endpoint}</code>
              {result && (
                <p className={`closing-cron__result ${result.ok ? "is-ok" : "is-error"}`}>
                  {result.message}
                </p>
              )}
              <button
                type="button"
                className="closing-cron__hit"
                disabled={loadingKey !== null}
                onClick={() => setPending(action)}
              >
                {busy ? "Running…" : "Hit closing"}
              </button>
            </article>
          );
        })}
      </div>

      <Modal
        show={Boolean(pending)}
        onHide={() => setPending(null)}
        centered
        className="closing-cron-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Run closing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pending
            ? `Run ${pending.label}? This hits ${pending.endpoint} and starts that closing job.`
            : null}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="closing-cron__cancel" onClick={() => setPending(null)}>
            Cancel
          </button>
          <button
            type="button"
            className="closing-cron__hit"
            onClick={() => pending && runAction(pending)}
          >
            Run now
          </button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default ClosingCron;
